export enum HelpCardVariant {
  default = 'default',
  withImage = 'with-image'
}
